// Translations for the app
export const translations = {
  fr: {
    announcement: "Annonce",
    understood: "J'ai compris",
    announceToStaff: "Annonce aux salariés",
    announcementTitle: "Titre (optionnel)",
    announcementMessage: "Votre message aux salariés…",
    publishAnnouncement: "Publier l'annonce",
    announcementPublished: "Annonce publiée",
    announcementAutoTranslate: "Le message sera traduit automatiquement (RU, MD, UK).",
    seenBy: "Vu par",
    notReadYet: "Pas encore lu",
    read: "Lu",
    removeAnnouncement: "Retirer l'annonce",
    announcementRemoved: "Annonce retirée",
    announcementHistory: "Historique des annonces",
    publishReplaces: "Publier une nouvelle annonce remplacera celle-ci.",
    // App name
    appName: "La Piscine Container",
    appSubtitle: "Gestion de Chantier",
    
    // Login page
    login: "Connexion",
    register: "Créer un compte",
    loginSubtitle: "Accédez à votre espace de travail",
    registerSubtitle: "Rejoignez votre équipe de chantier",
    email: "Email",
    password: "Mot de passe",
    fullName: "Nom complet",
    loginButton: "Se connecter",
    registerButton: "Créer mon compte",
    noAccount: "Pas encore de compte ? S'inscrire",
    hasAccount: "Déjà un compte ? Se connecter",
    loginSuccess: "Connexion réussie !",
    registerSuccess: "Compte créé avec succès !",
    
    // Navigation
    dashboard: "Tableau",
    attendance: "Pointage",
    projects: "Chantiers",
    materials: "Matériaux",
    photos: "Photos",
    messages: "Messages",
    profile: "Profil",
    commercial: "Commercial",
    logout: "Déconnexion",
    
    // Dashboard
    hello: "Bonjour",
    checkedInToday: "Vous êtes pointé aujourd'hui. Bonne journée de travail !",
    notCheckedIn: "N'oubliez pas de pointer votre présence aujourd'hui.",
    daysWorked: "Jours ce mois",
    activeProjects: "Chantiers actifs",
    photosLabel: "Photos",
    pendingMaterials: "Matériaux en attente",
    quickActions: "Actions rapides",
    checkInNow: "Pointer maintenant",
    recordPresence: "Enregistrez votre présence",
    addPhoto: "Ajouter une photo",
    documentSite: "Documentez votre chantier",
    materialsList: "Liste matériaux",
    manageNeeds: "Gérez vos besoins",
    unreadMessages: "non lu(s)",
    contactColleagues: "Contactez vos collègues",
    
    // Attendance
    attendanceTitle: "Pointage",
    checkedToday: "Pointé aujourd'hui",
    notCheckedToday: "Pas encore pointé",
    checkInButton: "Pointer maintenant",
    alreadyCheckedIn: "Bravo ! Vous avez déjà pointé aujourd'hui",
    checkInSuccess: "Bravo ! Vous avez pointé aujourd'hui !",
    totalDays: "Total jours",
    thisMonth: "Ce mois",
    presenceCalendar: "Calendrier de présence",
    present: "Présent",
    notRecorded: "Non pointé",
    recentHistory: "Historique récent",
    noAttendance: "Aucun pointage enregistré",
    
    // Projects
    projectsTitle: "Chantiers",
    newProject: "Nouveau chantier",
    inProgress: "En cours",
    completed: "Terminés",
    projectName: "Nom du chantier",
    description: "Description",
    startDate: "Date de début",
    estimatedDays: "Durée estimée (jours)",
    days: "jours",
    complete: "Terminer",
    completedOn: "Terminé le",
    noProjects: "Aucun chantier pour le moment",
    createFirst: "Créer le premier chantier",
    projectCreated: "Chantier créé !",
    projectUpdated: "Chantier mis à jour !",
    projectCompleted: "Chantier terminé !",
    deleteProjectConfirm: "Supprimer ce chantier ? Cela supprimera aussi les matériaux et photos associés.",
    addProject: "Ajouter un chantier",
    steps: "Étapes",
    addStep: "Ajouter une étape",
    stepName: "Nom de l'étape",
    progress: "Avancement",
    overallProgress: "Progression globale",
    preparation: "Préparation",
    works: "Travaux",
    finishing: "Finitions",
    cleaning: "Nettoyage",
    
    // Materials
    materialsTitle: "Liste des Matériaux",
    addMaterial: "Ajouter un matériau",
    filterByProject: "Filtrer par chantier",
    allProjects: "Tous les chantiers",
    pending: "En attente",
    completedLabel: "Complétés",
    materialName: "Nom du matériau",
    quantity: "Quantité",
    unit: "Unité",
    piece: "Pièce(s)",
    kg: "Kilogramme(s)",
    meter: "Mètre(s)",
    sqMeter: "Mètre² (m²)",
    cubicMeter: "Mètre³ (m³)",
    liter: "Litre(s)",
    bag: "Sac(s)",
    pallet: "Palette(s)",
    noMaterials: "Aucun matériau pour le moment",
    addFirstMaterial: "Ajouter le premier matériau",
    materialAdded: "Matériau ajouté !",
    materialDeleted: "Matériau supprimé",
    
    // Photos
    photosTitle: "Photos de Chantier",
    addPhotoButton: "Ajouter une photo",
    newPhoto: "Nouvelle Photo",
    selectProject: "Sélectionner un chantier",
    photoRequired: "Photo *",
    clickToSelect: "Cliquez pour sélectionner",
    descriptionOptional: "Description (optionnel)",
    describePhoto: "Décrivez la photo...",
    upload: "Uploader",
    cancel: "Annuler",
    noPhotos: "Aucune photo pour le moment",
    addFirstPhoto: "Ajouter la première photo",
    photoUploaded: "Photo uploadée !",
    photoDeleted: "Photo supprimée",
    deletePhotoConfirm: "Supprimer cette photo ?",
    by: "Par",
    delete: "Supprimer",
    
    // Chat
    messagesTitle: "Messages",
    searchUsers: "Rechercher...",
    conversations: "Conversations",
    allColleagues: "Tous les collègues",
    noColleagueFound: "Aucun collègue trouvé",
    startConversation: "Soyez le premier à envoyer un message !",
    online: "En ligne",
    writeMessage: "Écrire un message...",
    selectConversation: "Sélectionnez une conversation",
    orStartNew: "ou démarrez un nouveau chat",
    messageSendError: "Erreur lors de l'envoi",
    groupChat: "Chat de groupe",
    wholeTeam: "Toute l'équipe",
    members: "membres",
    
    // Profile
    profileTitle: "Mon Profil",
    information: "Informations",
    memberSince: "Membre depuis",
    actions: "Actions",
    logoutButton: "Se déconnecter",
    edit: "Modifier",
    save: "Sauver",
    photoUpdated: "Photo mise à jour !",
    profileUpdated: "Profil mis à jour !",
    selectImage: "Veuillez sélectionner une image",
    imageTooLarge: "Image trop volumineuse (max 5MB)",
    nameRequired: "Le nom ne peut pas être vide",
    employee: "Employé",
    manager: "Patron",
    admin: "Administrateur",
    
    // Language
    language: "Langue",
    french: "Français",
    russian: "Русский",
    moldovan: "Moldovenească",
    ukrainian: "Українська",
    
    // Common
    error: "Erreur",
    success: "Succès",
    loading: "Chargement...",
    update: "Mettre à jour",
    create: "Créer",
    photo: "photo(s)",
    
    // Additional translations
    today: "Aujourd'hui",
    yesterday: "Hier",
    team: "Équipe",
    equipment: "Entretien",
    send: "Envoyer",
    refresh: "Actualiser",
    sendPhoto: "Envoyer une photo",
    sendAddress: "Envoyer une adresse",
    captionOptional: "Légende (optionnel)",
    locationName: "Nom du lieu",
    address: "Adresse",
    openInMaps: "Ouvrir dans Maps",
    emojis: "Emojis",
    deleteMessage: "Supprimer",
    messageDeleted: "Message supprimé",
    deleteError: "Erreur de suppression",
    photoSent: "Photo envoyée",
    photosSent: "photos envoyées",
    addressSent: "Adresse envoyée",
    addressForMaterials: "Adresse pour matériaux",
    enterAddress: "Entrez une adresse",
    selectImages: "Sélectionnez des images",
    maxPhotos: "Maximum 5 photos à la fois",
    sendError: "Erreur d'envoi",
    updated: "Actualisé",
    attendanceRecords: "Pointages",
    fuel: "Carburant",
    expenses: "Notes de frais",
    noData: "Aucune donnée",
    editOvertime: "Modifier heures sup",
    deleteAttendance: "Supprimer ce pointage ?",
    attendanceDeleted: "Pointage supprimé",
    deleteFuelReceipt: "Supprimer ce justificatif carburant ?",
    receiptDeleted: "Justificatif supprimé",
    deleteExpense: "Supprimer cette note de frais ?",
    expenseDeleted: "Note de frais supprimée",
    overtimeUpdated: "Heures supplémentaires mises à jour",
    cannotDeleteManager: "Impossible de supprimer un manager",
    employeeUpdated: "Employé modifié",
    editMyProfile: "Modifier mon profil",
    name: "Nom",
    yourName: "Votre nom",
    rolePosition: "Rôle / Poste",
    roleExample: "Ex: Chef de chantier, Ouvrier, Manager...",
    titleRequired: "Le titre est obligatoire",
    notifications: "Notifications"
  },
  
  ru: {
    announcement: "Объявление",
    understood: "Понятно",
    announceToStaff: "Объявление для сотрудников",
    announcementTitle: "Заголовок (необязательно)",
    announcementMessage: "Ваше сообщение сотрудникам…",
    publishAnnouncement: "Опубликовать",
    announcementPublished: "Объявление опубликовано",
    announcementAutoTranslate: "Сообщение будет переведено автоматически (RU, MD, UK).",
    seenBy: "Просмотрели",
    notReadYet: "Ещё не прочитали",
    read: "Прочитали",
    removeAnnouncement: "Убрать объявление",
    announcementRemoved: "Объявление убрано",
    announcementHistory: "История объявлений",
    publishReplaces: "Новое объявление заменит текущее.",
    // App name
    appName: "La Piscine Container",
    appSubtitle: "Управление стройкой",
    
    // Login page
    login: "Вход",
    register: "Регистрация",
    loginSubtitle: "Войдите в свой рабочий кабинет",
    registerSubtitle: "Присоединяйтесь к команде",
    email: "Эл. почта",
    password: "Пароль",
    fullName: "Полное имя",
    loginButton: "Войти",
    registerButton: "Создать аккаунт",
    noAccount: "Нет аккаунта? Зарегистрироваться",
    hasAccount: "Уже есть аккаунт? Войти",
    loginSuccess: "Вход выполнен!",
    registerSuccess: "Аккаунт создан!",
    
    // Navigation
    dashboard: "Главная",
    attendance: "Посещение",
    projects: "Проекты",
    materials: "Материалы",
    photos: "Фото",
    messages: "Сообщения",
    profile: "Профиль",
    commercial: "Коммерческий",
    logout: "Выход",
    
    // Dashboard
    hello: "Привет",
    checkedInToday: "Вы отметились сегодня. Хорошего рабочего дня!",
    notCheckedIn: "Не забудьте отметить своё присутствие сегодня.",
    daysWorked: "Дней за месяц",
    activeProjects: "Активных проектов",
    photosLabel: "Фото",
    pendingMaterials: "Материалов в ожидании",
    quickActions: "Быстрые действия",
    checkInNow: "Отметиться сейчас",
    recordPresence: "Зафиксируйте присутствие",
    addPhoto: "Добавить фото",
    documentSite: "Задокументируйте стройку",
    materialsList: "Список материалов",
    manageNeeds: "Управляйте потребностями",
    unreadMessages: "непрочитанных",
    contactColleagues: "Свяжитесь с коллегами",
    
    // Attendance
    attendanceTitle: "Посещение",
    checkedToday: "Отмечено сегодня",
    notCheckedToday: "Ещё не отмечено",
    checkInButton: "Отметиться сейчас",
    alreadyCheckedIn: "Браво! Вы уже отметились сегодня",
    checkInSuccess: "Браво! Вы отметились сегодня!",
    totalDays: "Всего дней",
    thisMonth: "В этом месяце",
    presenceCalendar: "Календарь посещений",
    present: "Присутствовал",
    notRecorded: "Не отмечено",
    recentHistory: "Недавняя история",
    noAttendance: "Нет записей о посещении",
    
    // Projects
    projectsTitle: "Проекты",
    newProject: "Новый проект",
    inProgress: "В работе",
    completed: "Завершённые",
    projectName: "Название проекта",
    description: "Описание",
    startDate: "Дата начала",
    estimatedDays: "Планируемый срок (дней)",
    days: "дней",
    complete: "Завершить",
    completedOn: "Завершён",
    noProjects: "Пока нет проектов",
    createFirst: "Создать первый проект",
    projectCreated: "Проект создан!",
    projectUpdated: "Проект обновлён!",
    projectCompleted: "Проект завершён!",
    deleteProjectConfirm: "Удалить проект? Это также удалит связанные материалы и фото.",
    addProject: "Добавить проект",
    steps: "Этапы",
    addStep: "Добавить этап",
    stepName: "Название этапа",
    progress: "Прогресс",
    overallProgress: "Общий прогресс",
    preparation: "Подготовка",
    works: "Работы",
    finishing: "Отделка",
    cleaning: "Уборка",
    
    // Materials
    materialsTitle: "Список материалов",
    addMaterial: "Добавить материал",
    filterByProject: "Фильтр по проекту",
    allProjects: "Все проекты",
    pending: "В ожидании",
    completedLabel: "Выполнено",
    materialName: "Название материала",
    quantity: "Количество",
    unit: "Единица",
    piece: "Штука(и)",
    kg: "Килограмм(ы)",
    meter: "Метр(ы)",
    sqMeter: "Метр² (м²)",
    cubicMeter: "Метр³ (м³)",
    liter: "Литр(ы)",
    bag: "Мешок(и)",
    pallet: "Поддон(ы)",
    noMaterials: "Пока нет материалов",
    addFirstMaterial: "Добавить первый материал",
    materialAdded: "Материал добавлен!",
    materialDeleted: "Материал удалён",
    
    // Photos
    photosTitle: "Фото стройки",
    addPhotoButton: "Добавить фото",
    newPhoto: "Новое фото",
    selectProject: "Выберите проект",
    photoRequired: "Фото *",
    clickToSelect: "Нажмите для выбора",
    descriptionOptional: "Описание (необязательно)",
    describePhoto: "Опишите фото...",
    upload: "Загрузить",
    cancel: "Отмена",
    noPhotos: "Пока нет фото",
    addFirstPhoto: "Добавить первое фото",
    photoUploaded: "Фото загружено!",
    photoDeleted: "Фото удалено",
    deletePhotoConfirm: "Удалить это фото?",
    by: "От",
    delete: "Удалить",
    
    // Chat
    messagesTitle: "Сообщения",
    searchUsers: "Поиск...",
    conversations: "Беседы",
    allColleagues: "Все коллеги",
    noColleagueFound: "Коллега не найден",
    startConversation: "Будьте первым, кто отправит сообщение!",
    online: "В сети",
    writeMessage: "Написать сообщение...",
    selectConversation: "Выберите беседу",
    orStartNew: "или начните новый чат",
    messageSendError: "Ошибка отправки",
    groupChat: "Групповой чат",
    wholeTeam: "Вся команда",
    members: "участников",
    
    // Profile
    profileTitle: "Мой профиль",
    information: "Информация",
    memberSince: "Участник с",
    actions: "Действия",
    logoutButton: "Выйти",
    edit: "Изменить",
    save: "Сохранить",
    photoUpdated: "Фото обновлено!",
    profileUpdated: "Профиль обновлён!",
    selectImage: "Выберите изображение",
    imageTooLarge: "Изображение слишком большое (макс 5МБ)",
    nameRequired: "Имя не может быть пустым",
    employee: "Сотрудник",
    manager: "Шеф",
    admin: "Администратор",
    
    // Language
    language: "Язык",
    french: "Français",
    russian: "Русский",
    moldovan: "Moldovenească",
    ukrainian: "Українська",
    
    // Common
    error: "Ошибка",
    success: "Успех",
    loading: "Загрузка...",
    update: "Обновить",
    create: "Создать",
    photo: "фото",
    
    // Additional translations
    today: "Сегодня",
    yesterday: "Вчера",
    team: "Команда",
    equipment: "Обслуживание",
    send: "Отправить",
    refresh: "Обновить",
    sendPhoto: "Отправить фото",
    sendAddress: "Отправить адрес",
    captionOptional: "Подпись (необязательно)",
    locationName: "Название места",
    address: "Адрес",
    openInMaps: "Открыть в картах",
    emojis: "Эмодзи",
    deleteMessage: "Удалить",
    messageDeleted: "Сообщение удалено",
    deleteError: "Ошибка удаления",
    photoSent: "Фото отправлено",
    photosSent: "фото отправлено",
    addressSent: "Адрес отправлен",
    addressForMaterials: "Адрес для материалов",
    enterAddress: "Введите адрес",
    selectImages: "Выберите изображения",
    maxPhotos: "Максимум 5 фото за раз",
    sendError: "Ошибка отправки",
    updated: "Обновлено",
    attendanceRecords: "Посещения",
    fuel: "Топливо",
    expenses: "Расходы",
    noData: "Нет данных",
    editOvertime: "Редактировать сверхурочные",
    deleteAttendance: "Удалить это посещение?",
    attendanceDeleted: "Посещение удалено",
    deleteFuelReceipt: "Удалить этот чек на топливо?",
    receiptDeleted: "Чек удалён",
    deleteExpense: "Удалить этот расход?",
    expenseDeleted: "Расход удалён",
    overtimeUpdated: "Сверхурочные обновлены",
    cannotDeleteManager: "Невозможно удалить менеджера",
    employeeUpdated: "Сотрудник обновлён",
    editMyProfile: "Редактировать профиль",
    name: "Имя",
    yourName: "Ваше имя",
    rolePosition: "Роль / Должность",
    roleExample: "Напр: Прораб, Рабочий, Менеджер...",
    titleRequired: "Заголовок обязателен",
    notifications: "Уведомления"
  },
  
  md: {
    announcement: "Anunț",
    understood: "Am înțeles",
    announceToStaff: "Anunț pentru angajați",
    announcementTitle: "Titlu (opțional)",
    announcementMessage: "Mesajul dvs. pentru angajați…",
    publishAnnouncement: "Publică anunțul",
    announcementPublished: "Anunț publicat",
    announcementAutoTranslate: "Mesajul va fi tradus automat (RU, MD, UK).",
    seenBy: "Văzut de",
    notReadYet: "Încă necitit",
    read: "Citit",
    removeAnnouncement: "Retrage anunțul",
    announcementRemoved: "Anunț retras",
    announcementHistory: "Istoricul anunțurilor",
    publishReplaces: "Un anunț nou îl va înlocui pe acesta.",
    // App name
    appName: "La Piscine Container",
    appSubtitle: "Gestiunea Șantierului",
    
    // Login page
    login: "Autentificare",
    register: "Creează cont",
    loginSubtitle: "Accesați spațiul de lucru",
    registerSubtitle: "Alăturați-vă echipei",
    email: "Email",
    password: "Parolă",
    fullName: "Nume complet",
    loginButton: "Conectare",
    registerButton: "Creează contul",
    noAccount: "Nu ai cont? Înregistrează-te",
    hasAccount: "Ai deja cont? Conectează-te",
    loginSuccess: "Conectare reușită!",
    registerSuccess: "Cont creat cu succes!",
    
    // Navigation
    dashboard: "Panou",
    attendance: "Prezență",
    projects: "Șantiere",
    materials: "Materiale",
    photos: "Fotografii",
    messages: "Mesaje",
    profile: "Profil",
    commercial: "Comercial",
    logout: "Deconectare",
    
    // Dashboard
    hello: "Bună",
    checkedInToday: "Ai marcat prezența azi. O zi bună de muncă!",
    notCheckedIn: "Nu uita să marchezi prezența azi.",
    daysWorked: "Zile luna aceasta",
    activeProjects: "Șantiere active",
    photosLabel: "Fotografii",
    pendingMaterials: "Materiale în așteptare",
    quickActions: "Acțiuni rapide",
    checkInNow: "Marchează acum",
    recordPresence: "Înregistrează prezența",
    addPhoto: "Adaugă foto",
    documentSite: "Documentează șantierul",
    materialsList: "Lista materiale",
    manageNeeds: "Gestionează nevoile",
    unreadMessages: "necitit(e)",
    contactColleagues: "Contactează colegii",
    
    // Attendance
    attendanceTitle: "Prezență",
    checkedToday: "Marcat azi",
    notCheckedToday: "Încă nemarcat",
    checkInButton: "Marchează acum",
    alreadyCheckedIn: "Bravo! Ai punctat deja azi",
    checkInSuccess: "Bravo! Ai punctat azi!",
    totalDays: "Total zile",
    thisMonth: "Luna aceasta",
    presenceCalendar: "Calendar prezență",
    present: "Prezent",
    notRecorded: "Nemarcat",
    recentHistory: "Istoric recent",
    noAttendance: "Nicio înregistrare",
    
    // Projects
    projectsTitle: "Șantiere",
    newProject: "Șantier nou",
    inProgress: "În lucru",
    completed: "Finalizate",
    projectName: "Nume șantier",
    description: "Descriere",
    startDate: "Data începerii",
    estimatedDays: "Durată estimată (zile)",
    days: "zile",
    complete: "Finalizează",
    completedOn: "Finalizat pe",
    noProjects: "Niciun șantier momentan",
    createFirst: "Creează primul șantier",
    projectCreated: "Șantier creat!",
    projectUpdated: "Șantier actualizat!",
    projectCompleted: "Șantier finalizat!",
    deleteProjectConfirm: "Ștergi acest șantier? Vor fi șterse și materialele și fotografiile asociate.",
    addProject: "Adaugă un șantier",
    steps: "Etape",
    addStep: "Adaugă etapă",
    stepName: "Nume etapă",
    progress: "Progres",
    overallProgress: "Progres general",
    preparation: "Pregătire",
    works: "Lucrări",
    finishing: "Finisaje",
    cleaning: "Curățenie",
    
    // Materials
    materialsTitle: "Lista Materialelor",
    addMaterial: "Adaugă material",
    filterByProject: "Filtrează după șantier",
    allProjects: "Toate șantierele",
    pending: "În așteptare",
    completedLabel: "Completate",
    materialName: "Nume material",
    quantity: "Cantitate",
    unit: "Unitate",
    piece: "Bucată(i)",
    kg: "Kilogram(e)",
    meter: "Metru(i)",
    sqMeter: "Metru² (m²)",
    cubicMeter: "Metru³ (m³)",
    liter: "Litru(i)",
    bag: "Sac(i)",
    pallet: "Palet(i)",
    noMaterials: "Niciun material momentan",
    addFirstMaterial: "Adaugă primul material",
    materialAdded: "Material adăugat!",
    materialDeleted: "Material șters",
    
    // Photos
    photosTitle: "Fotografii Șantier",
    addPhotoButton: "Adaugă foto",
    newPhoto: "Fotografie Nouă",
    selectProject: "Selectează șantierul",
    photoRequired: "Foto *",
    clickToSelect: "Click pentru a selecta",
    descriptionOptional: "Descriere (opțional)",
    describePhoto: "Descrie fotografia...",
    upload: "Încarcă",
    cancel: "Anulează",
    noPhotos: "Nicio fotografie momentan",
    addFirstPhoto: "Adaugă prima fotografie",
    photoUploaded: "Foto încărcată!",
    photoDeleted: "Foto ștearsă",
    deletePhotoConfirm: "Ștergi această fotografie?",
    by: "De",
    delete: "Șterge",
    
    // Chat
    messagesTitle: "Mesaje",
    searchUsers: "Caută...",
    conversations: "Conversații",
    allColleagues: "Toți colegii",
    noColleagueFound: "Niciun coleg găsit",
    startConversation: "Fii primul care trimite un mesaj!",
    online: "Online",
    writeMessage: "Scrie un mesaj...",
    selectConversation: "Selectează o conversație",
    orStartNew: "sau începe un chat nou",
    messageSendError: "Eroare la trimitere",
    groupChat: "Chat de grup",
    wholeTeam: "Toată echipa",
    members: "membri",
    
    // Profile
    profileTitle: "Profilul Meu",
    information: "Informații",
    memberSince: "Membru din",
    actions: "Acțiuni",
    logoutButton: "Deconectare",
    edit: "Modifică",
    save: "Salvează",
    photoUpdated: "Foto actualizată!",
    profileUpdated: "Profil actualizat!",
    selectImage: "Selectează o imagine",
    imageTooLarge: "Imagine prea mare (max 5MB)",
    nameRequired: "Numele nu poate fi gol",
    employee: "Angajat",
    manager: "Patron",
    admin: "Administrator",
    
    // Language
    language: "Limbă",
    french: "Français",
    russian: "Русский",
    moldovan: "Moldovenească",
    ukrainian: "Українська",
    
    // Common
    error: "Eroare",
    success: "Succes",
    loading: "Se încarcă...",
    update: "Actualizează",
    create: "Creează",
    photo: "foto",
    
    // Additional translations
    today: "Astăzi",
    yesterday: "Ieri",
    team: "Echipă",
    equipment: "Întreținere",
    send: "Trimite",
    refresh: "Actualizează",
    sendPhoto: "Trimite foto",
    sendAddress: "Trimite adresă",
    captionOptional: "Legendă (opțional)",
    locationName: "Nume loc",
    address: "Adresă",
    openInMaps: "Deschide în hărți",
    emojis: "Emoji",
    deleteMessage: "Șterge",
    messageDeleted: "Mesaj șters",
    deleteError: "Eroare la ștergere",
    photoSent: "Fotografie trimisă",
    photosSent: "fotografii trimise",
    addressSent: "Adresă trimisă",
    addressForMaterials: "Adresă pentru materiale",
    enterAddress: "Introduceți adresa",
    selectImages: "Selectați imagini",
    maxPhotos: "Maximum 5 fotografii odată",
    sendError: "Eroare de trimitere",
    updated: "Actualizat",
    attendanceRecords: "Prezențe",
    fuel: "Combustibil",
    expenses: "Cheltuieli",
    noData: "Nicio dată",
    editOvertime: "Editează ore suplimentare",
    deleteAttendance: "Ștergi această prezență?",
    attendanceDeleted: "Prezență ștearsă",
    deleteFuelReceipt: "Ștergi acest bon combustibil?",
    receiptDeleted: "Bon șters",
    deleteExpense: "Ștergi această cheltuială?",
    expenseDeleted: "Cheltuială ștearsă",
    overtimeUpdated: "Ore suplimentare actualizate",
    cannotDeleteManager: "Nu se poate șterge un manager",
    employeeUpdated: "Angajat actualizat",
    editMyProfile: "Editează profilul meu",
    name: "Nume",
    yourName: "Numele tău",
    rolePosition: "Rol / Funcție",
    roleExample: "Ex: Șef șantier, Muncitor, Manager...",
    titleRequired: "Titlul este obligatoriu",
    notifications: "Notificări"
  },

  uk: {
    announcement: "Оголошення",
    understood: "Зрозуміло",
    announceToStaff: "Оголошення для працівників",
    announcementTitle: "Заголовок (необов'язково)",
    announcementMessage: "Ваше повідомлення працівникам…",
    publishAnnouncement: "Опублікувати",
    announcementPublished: "Оголошення опубліковано",
    announcementAutoTranslate: "Повідомлення буде перекладено автоматично (RU, MD, UK).",
    seenBy: "Переглянули",
    notReadYet: "Ще не прочитали",
    read: "Прочитали",
    removeAnnouncement: "Прибрати оголошення",
    announcementRemoved: "Оголошення прибрано",
    announcementHistory: "Історія оголошень",
    publishReplaces: "Нове оголошення замінить поточне.",
    // App name
    appName: "La Piscine Container",
    appSubtitle: "Управління будівництвом",
    
    // Login page
    login: "Вхід",
    register: "Створити обліковий запис",
    loginSubtitle: "Увійдіть до робочого простору",
    registerSubtitle: "Приєднуйтесь до будівельної команди",
    email: "Електронна пошта",
    password: "Пароль",
    fullName: "Повне ім'я",
    loginButton: "Увійти",
    registerButton: "Створити обліковий запис",
    noAccount: "Немає облікового запису? Зареєструватися",
    hasAccount: "Вже є обліковий запис? Увійти",
    loginSuccess: "Вхід успішний!",
    registerSuccess: "Обліковий запис створено!",
    
    // Navigation
    dashboard: "Панель",
    attendance: "Відвідуваність",
    projects: "Об'єкти",
    materials: "Матеріали",
    photos: "Фото",
    messages: "Повідомлення",
    profile: "Профіль",
    commercial: "Комерційний",
    logout: "Вийти",
    
    // Dashboard
    hello: "Привіт",
    checkedInToday: "Ви відмітились сьогодні. Гарного робочого дня!",
    notCheckedIn: "Не забудьте відмітити свою присутність сьогодні.",
    daysWorked: "Днів за місяць",
    activeProjects: "Активні об'єкти",
    photosLabel: "Фото",
    pendingMaterials: "Матеріали в очікуванні",
    quickActions: "Швидкі дії",
    checkInNow: "Відмітитись зараз",
    recordPresence: "Зафіксуйте свою присутність",
    addPhoto: "Додати фото",
    documentSite: "Задокументуйте об'єкт",
    materialsList: "Список матеріалів",
    manageNeeds: "Керуйте потребами",
    unreadMessages: "непрочитано",
    contactColleagues: "Зв'яжіться з колегами",
    
    // Attendance
    attendanceTitle: "Відвідуваність",
    checkedToday: "Відмічено сьогодні",
    notCheckedToday: "Ще не відмічено",
    checkInButton: "Відмітитись зараз",
    alreadyCheckedIn: "Чудово! Ви вже відмітились сьогодні",
    checkInSuccess: "Чудово! Ви відмітились сьогодні!",
    totalDays: "Всього днів",
    thisMonth: "Цей місяць",
    presenceCalendar: "Календар присутності",
    present: "Присутній",
    notRecorded: "Не відмічено",
    recentHistory: "Остання історія",
    noAttendance: "Записів про відвідуваність немає",
    
    // Projects
    projectsTitle: "Об'єкти",
    newProject: "Новий об'єкт",
    inProgress: "В роботі",
    completed: "Завершені",
    projectName: "Назва об'єкта",
    description: "Опис",
    startDate: "Дата початку",
    estimatedDays: "Орієнтовна тривалість (днів)",
    days: "днів",
    complete: "Завершити",
    completedOn: "Завершено",
    noProjects: "Об'єктів поки немає",
    createFirst: "Створити перший об'єкт",
    projectCreated: "Об'єкт створено!",
    projectUpdated: "Об'єкт оновлено!",
    projectCompleted: "Об'єкт завершено!",
    deleteProjectConfirm: "Видалити цей об'єкт? Це також видалить пов'язані матеріали та фото.",
    addProject: "Додати об'єкт",
    steps: "Етапи",
    addStep: "Додати етап",
    stepName: "Назва етапу",
    progress: "Прогрес",
    overallProgress: "Загальний прогрес",
    preparation: "Підготовка",
    works: "Роботи",
    finishing: "Оздоблення",
    cleaning: "Прибирання",
    
    // Materials
    materialsTitle: "Список матеріалів",
    addMaterial: "Додати матеріал",
    filterByProject: "Фільтрувати за об'єктом",
    allProjects: "Всі об'єкти",
    pending: "В очікуванні",
    completedLabel: "Завершені",
    materialName: "Назва матеріалу",
    quantity: "Кількість",
    unit: "Одиниця",
    piece: "Штука",
    kg: "Кілограм",
    meter: "Метр",
    sqMeter: "Метр² (м²)",
    cubicMeter: "Метр³ (м³)",
    liter: "Літр",
    bag: "Мішок",
    pallet: "Палета",
    noMaterials: "Матеріалів поки немає",
    addFirstMaterial: "Додати перший матеріал",
    materialAdded: "Матеріал додано!",
    materialDeleted: "Матеріал видалено",
    
    // Photos
    photosTitle: "Фото об'єкта",
    addPhotoButton: "Додати фото",
    newPhoto: "Нове фото",
    selectProject: "Виберіть об'єкт",
    photoRequired: "Фото *",
    clickToSelect: "Натисніть для вибору",
    descriptionOptional: "Опис (необов'язково)",
    describePhoto: "Опишіть фото...",
    upload: "Завантажити",
    cancel: "Скасувати",
    noPhotos: "Фото поки немає",
    addFirstPhoto: "Додати перше фото",
    photoUploaded: "Фото завантажено!",
    photoDeleted: "Фото видалено",
    deletePhotoConfirm: "Видалити це фото?",
    by: "Від",
    delete: "Видалити",
    
    // Chat
    messagesTitle: "Повідомлення",
    searchUsers: "Пошук...",
    conversations: "Розмови",
    allColleagues: "Всі колеги",
    noColleagueFound: "Колег не знайдено",
    startConversation: "Будьте першим, хто напише!",
    online: "Онлайн",
    writeMessage: "Написати повідомлення...",
    selectConversation: "Виберіть розмову",
    orStartNew: "або почніть новий чат",
    messageSendError: "Помилка відправлення",
    groupChat: "Груповий чат",
    wholeTeam: "Вся команда",
    members: "учасників",
    
    // Profile
    profileTitle: "Мій профіль",
    information: "Інформація",
    memberSince: "Учасник з",
    actions: "Дії",
    logoutButton: "Вийти",
    edit: "Редагувати",
    save: "Зберегти",
    photoUpdated: "Фото оновлено!",
    profileUpdated: "Профіль оновлено!",
    selectImage: "Виберіть зображення",
    imageTooLarge: "Зображення занадто велике (макс 5МБ)",
    nameRequired: "Ім'я не може бути порожнім",
    employee: "Працівник",
    manager: "Шеф",
    admin: "Адміністратор",
    
    // Language
    language: "Мова",
    french: "Français",
    russian: "Русский",
    moldovan: "Moldovenească",
    ukrainian: "Українська",
    
    // Common
    error: "Помилка",
    success: "Успіх",
    loading: "Завантаження...",
    update: "Оновити",
    create: "Створити",
    photo: "фото",
    
    // Additional translations
    today: "Сьогодні",
    yesterday: "Вчора",
    team: "Команда",
    equipment: "Обслуговування",
    send: "Надіслати",
    refresh: "Оновити",
    sendPhoto: "Надіслати фото",
    sendAddress: "Надіслати адресу",
    captionOptional: "Підпис (необов'язково)",
    locationName: "Назва місця",
    address: "Адреса",
    openInMaps: "Відкрити в картах",
    emojis: "Емодзі",
    deleteMessage: "Видалити",
    messageDeleted: "Повідомлення видалено",
    deleteError: "Помилка видалення",
    photoSent: "Фото надіслано",
    photosSent: "фото надіслано",
    addressSent: "Адресу надіслано",
    addressForMaterials: "Адреса для матеріалів",
    enterAddress: "Введіть адресу",
    selectImages: "Виберіть зображення",
    maxPhotos: "Максимум 5 фото за раз",
    sendError: "Помилка надсилання",
    updated: "Оновлено",
    attendanceRecords: "Відвідування",
    fuel: "Паливо",
    expenses: "Витрати",
    noData: "Немає даних",
    editOvertime: "Редагувати понаднормові",
    deleteAttendance: "Видалити це відвідування?",
    attendanceDeleted: "Відвідування видалено",
    deleteFuelReceipt: "Видалити цей чек на паливо?",
    receiptDeleted: "Чек видалено",
    deleteExpense: "Видалити цю витрату?",
    expenseDeleted: "Витрату видалено",
    overtimeUpdated: "Понаднормові оновлено",
    cannotDeleteManager: "Неможливо видалити менеджера",
    employeeUpdated: "Працівника оновлено",
    editMyProfile: "Редагувати мій профіль",
    name: "Ім'я",
    yourName: "Ваше ім'я",
    rolePosition: "Роль / Посада",
    roleExample: "Напр: Прораб, Робітник, Менеджер...",
    titleRequired: "Заголовок обов'язковий",
    notifications: "Сповіщення"
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.fr[key] || key;
};
